import { IAverageRating, ICompanyPosition } from 'src/interfaces/reviews';

import { PAGE_TYPE } from '@sravni/ugc/lib/organizations/constants';
import { TOrganizationTypes } from '@sravni/ugc/lib/organizations/types';

export enum OrganizationType {
  BANK = 'bank',
  MFO = 'mfo',
  INSURANCE = 'insuranceCompany',
  SCHOOL = 'educationalOrganization',
  BROKER = 'broker',
  NPF = 'npf',
  LEASING = 'leasing',
  MARKETPLACE = 'marketplace',
  BANKRUPTCY = 'bankruptcy',
  UNIVERSITY = 'university',
  BOOKMAKER = 'bookmaker',
  OFFLINE_SCHOOL = 'offlineSchool',
}

export enum OrganizationStatuses {
  ACTIVE = 'active',
  HIDDEN = 'hidden',
  ARCHIVED = 'archived',
  ABSORBED = 'absorbed',
}

export interface IMenu {
  href: string;
  label: string;
  isLink?: boolean;
  children?: any[];
}

export interface ILinks {
  key: string;
  link: string;
}

export interface IContacts {
  address?: string;
  legalAddress?: string;
  website: string;
  phone?: string[];
  email?: string[];
  apps?: ILinks[];
  socialsNetworks?: ILinks[];
  personalAccountName?: string;
  personalAccountSite?: string;
  leadership?: string;
  shareholders?: string;
}

export interface IRequisites {
  bik: string;
  ogrn?: string;
  inn?: string;
  kpp?: string;
  okpo?: string;
  swift?: string;
  other?: string;
}

export interface IName {
  short: string;
  full?: string;
  official?: string;
  genitive?: string;
  accusative?: string;
  dative?: string;
  instrumental?: string;
  prepositional?: string;
}

export interface IRating {
  assets?: number;
  assetsDelta?: number;
  assetsRating?: number;
  assetsRatingPosition?: number;
  bankBranchRating?: number;
  bankBranchesCount?: number;
  cashPointRating?: number;
  cashPointsCount?: number;
  clientRating?: number;
  clientRatingMark?: null;
  clientRatingPosition?: number;
  clientRatingType?: string;
  credits?: number;
  creditsDelta?: number;
  creditsRating?: number;
  creditsRatingPosition?: number;
  deposites?: number;
  depositesDelta?: number;
  depositesRating?: number;
  depositesRatingPosition?: number;
  deposits?: number;
  profit?: number;
  profitDelta?: number;
  profitRating?: number;
  profitRatingPosition?: number;
  sravniRuRating?: number;
}

export interface ILicense {
  key: string;
  organization: string;
  date: string;
}

// интерфейс для схемы из organizations service
export interface OrganizationServiceItem {
  _id: string;
  type: OrganizationType;
  status: OrganizationStatuses;
  name: IName;
  alias: string;
  oldId: number;
  license: string; // 0 - если нет лицензии
  absorbedBy?: string;
  logotypes: {
    web: string;
    android: string;
    square: string;
  };
  created: string;
  updated: string;

  contacts: IContacts;
  requisites: IRequisites;
  locations: string[];
  description?: string;
  servicesForIndividuals?: string;
  servicesForLegalEntities?: string;

  schedule?: null | [];
  registrationDate: string;
  ratings?: IRating;
  licenses?: ILicense[];
  partnerCard: boolean;
  stats?: {
    courses?: number;
  };
  hasOffersId?: number;
}

export interface InsuranceServiceItem {
  id: number;
  alias: string;
  code: string;
  name: string;
  fullName: string;
  inn: number;
  raRating: string;
  raRatingNumeric: number;
  raRatingDescription: string;
  phones: string[];
  status: 'Archived' | 'Active';
  description: string;
  isRecomended: boolean;
}

// нормальизованая общая схема для organizations service и insurance service
export interface IItem {
  _id?: string;
  id: string;
  oldId?: number | string; // сущевствует только в организациях из organization service
  alias: string;
  status: OrganizationStatuses;
  name: string;
  fullName: string;
  prepositionalName: string;
  description: string;
  type: OrganizationType;
  logo: string;
  roundLogo: string;
  squareLogo: string;
  isRecomended?: boolean;
  partnerCard?: boolean;
  cbWebsite?: string;
  license?: string;

  // временные поля
  isBank?: boolean;
  isInsurance?: boolean;
  isMfo?: boolean;

  stats?: {
    courses?: number;
  };

  ad?: {
    clickLink?: string;
    displayLink?: string;
    clickCost?: number;
    buttonText?: string;
    buttonMobileText?: string;
    productType?: string;
    utmString?: string;
  };

  contacts: OrganizationServiceItem['contacts'];
  hasOffersId: OrganizationServiceItem['hasOffersId'];
  rating?: IAverageRating[];
  position?: ICompanyPosition;
}

export type IOrganizationAliasesRedirects = Record<string, string>;

export interface IOrganizationMenuQuery {
  type: PAGE_TYPE;
  id: string | number;
  alias: string;
  location: string;
  status: OrganizationStatuses;
  isPartner: boolean;
  counts?: boolean;
}

export interface IFetchOrganizationsListParams {
  organizationType: TOrganizationTypes;
}

export interface IOrganizationMapResponse {
  map: Record<string, { [key: string]: any }>;
}
